<template>
<div>
    <Breadcrumb :title="'Investment Valuation Upload'"></Breadcrumb>
    <div class="row no-gutters">

        <div class="col">
             <button class="btn btn-primary" style="float:right;" @click.prevent='downloadTemplate'><span class="fa fa-download"></span> Download Template</button>
             <button class="btn btn-secondary" style="float:right;margin-right:10px;" @click.prevent='backtoInvestment'>
                <span class="k-icon k-i-undo" >  </span> &nbsp;Back to Investment Valuation
                </button>
           
        </div>
    </div>
    <div class="row">
        <br>

</div>
        <BaseAuditDropzone :id="'InvestmentValuation'" ref="ParentFileUploaded" :acceptedFileTypes="SheetJSFT" @change="_change"  @Remove="ClearForm" :File="inputfile" :UploadType="FileUploadType"></BaseAuditDropzone>
        <br><br>

        <div id="pageErrors" class="alert alert-danger"  v-if="pageErrors.length>0">
            <p >
            <b >Please correct the following error(s):</b>
            <ul >
            <li  v-for="error in pageErrors" :key="error">{{ error }}</li>
            </ul>
            </p>
          </div>
          <br>

        <div v-show="displayPage">
        <div class="row no-gutters" >
            <div class="col">
                <div class="form-row">
                    <div class="col-md-12">
                        <BaseGrid :mode="'editform'" :config="InvestmentValuationUploadConfig" :data="dataInvestmentValuationExcel" @DeleteItem="DeleteDIfromGrid">
                            <!-- @EditItem="EditPartner"  -->
                        </BaseGrid>
                    </div>
                </div>
            </div>
        </div>
        
            <div class="row">
                <br>

</div>
                 <div class="row no-gutters" style='float: right;margin-left:15px;'>
                    <button type="button" id="btnSave" class="btn btn-primary" :disabled="(!bValidated || pageErrors.length>0 || dataInvestmentValuationExcel.length<=0)" @click.prevent="SaveInvestments">Save</button>

                </div>
                 <div class="row no-gutters" style='float: right;'>
                    <button type="button" id="btnSave" class="btn btn-secondary" @click.prevent="validateFn">Validate</button>
                </div>
                <div class="row">
                    <br><br>

</div>
                </div>

            </div>
</template>

<script>
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import customAxios from "@/services/customAxios.js";
import { getUrl } from "../../configs/assets.js";
import { getFileName } from "../../configs/assets.js";
import Breadcrumb from "@/components/layout/Breadcrumb.vue";
import BaseGrid from "@/components/base/BaseGrid.vue";
import BaseAuditDropzone from "@/components/base/BaseAuditDropzone.vue";
import moment from "moment";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import BaseInvestment from '@/models/BaseModelInvestment.js';
import BasePartner from '@/models/BaseModelPartner.js';
import BaseModelInvestmentValuation from '@/models/BaseModelInvestmentValuation.js'
import BaseModelInputControl  from "@/models/BaseModelInputControl.js";
import { isNullOrUndefined } from "util";

import {
    mapActions,
    mapState,
    mapGetters
} from 'vuex';
import {
    InvestmentValuationUploadConfig
} from '@/views/investment/InvestmentValuationUploadConfig.js'
import XLSX from "xlsx";
import sheetJSConfig from "@/configs/sheetJS.js";
import DocumentManagerMixin from "@/mixins/DocumentManagerMixin.js";
import bulkUploadAuditConfig from "@/models/BaseModelAuditUploadDocument.js";

export default {
    mixins: [apiUtil, funcUtil,DocumentManagerMixin],
    data() {
        return {
            data: "",
            inputfile: {
                UploadFile: {}
            },
            //UploadFile:excelfile,
            displayPage: false,
            FileUploadType: {
                AllowMultiple: "false"
            },
            SheetJSFT: sheetJSConfig.fileType,
            InvestmentValuationUploadConfig: InvestmentValuationUploadConfig,
            dataInvestmentValuationExcel: [],
            pageErrors: [],
            PartnerAPIData: [],
            InvestmentAPIData: [],
            InvestmentValuationAPIData: [],
            BaseModelInputControl:BaseModelInputControl,
            Columns:[],
            TaxYearOptions:[],
            TaxQuarterOptions:[],
            bValidated:false,
            bulkUploadAuditConfig: bulkUploadAuditConfig,
        };
    },
    components: {
        BaseGrid,
        Breadcrumb,
        BaseAuditDropzone,
    },
    computed: {
        ...mapState("postModule", ["response"]),
        ...mapGetters("getModule", ["getAllItemFilter","getLocalInputControls"])
    },
    methods: {
        ...mapActions("postModule", ["CreateAllItems","PostAllFilesAndUpdateMetadata","PostAllAuditFilesAndUpdateMetadata"]),
        _suppress(evt) {
            evt.stopPropagation();
            evt.preventDefault();
        },
        downloadTemplate() {
           let token = localStorage.getItem("eum")
           let tokenstr = `Bearer ${token}`
           let templateUrl = getUrl("InvestmentValuation");
           let templateFileName = getFileName("InvestmentValuation");
            
           customAxios({
              url: templateUrl,
              method: 'GET',
              headers: {
                'Authorization': tokenstr
              },
              responseType: 'blob', // important,
            }).then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', decodeURIComponent(templateFileName));
         document.body.appendChild(link);
              link.click();
            });

        },

        _drop(evt) {
            evt.stopPropagation();
            evt.preventDefault();
            const files = evt.BaseModelTransfer.files;
            if (files && files[0]) this._file(files[0]);
        },
        _change(evt) {
            const files = this.inputfile.UploadFile[0];
            if (files) this._file(files);
        },
        backtoInvestment: function() {
      this.$router.push("/valuation/investmentvaluation");
        },
        _export(evt) {
            /* convert state to workbook */
            const ws = XLSX.utils.aoa_to_sheet(this.data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
            /* generate file and send to client */
            XLSX.writeFile(wb, "sheetjs.xlsx");
        },
        _file(file) {
            /* Boilerplate to set up FileReader */
            try {
                const reader = new FileReader();
                reader.onload = e => {
                    /* Parse data */
                    //const bstr = e.target.result;
                    let binary = "";
                    let bytes = new Uint8Array(e.target.result);
                    let length = bytes.byteLength;

                    for (let i = 0; i < length; i++) 
                    {
                        binary += String.fromCharCode(bytes[i]);
                    }
                    const bstr = binary
                    const wb = XLSX.read(bstr, {
                        type: "binary"
                    });
                    /* Get Partner  data */
                    const wsname = wb.SheetNames[0];
                    const ws = wb.Sheets[wsname];
                    const data = XLSX.utils.sheet_to_json(ws, {
											range: sheetJSConfig.template.header - 1, 
                        header: 1
                    });
                    console.log(data);
                    data.splice(0, 1);
                    if (data && data.length) {
                        //get partner and investment
                        let response=this.getAllItemFilter({
                            // Partner: {
                            //     config: BasePartner
                            // },
                            Investment: {
                                config: BaseInvestment
                            },
                            InvestmentValuation: {
                                config: BaseModelInvestmentValuation
                            },
                            

                        });
                        if(response)
                        {
                            // this.PartnerAPIData = response.Partner;
                            this.InvestmentAPIData = response.Investment;
                            this.InvestmentValuationAPIData = response.InvestmentValuation;
                        }
                        //if (this.HeaderRow != "") {
                        this.displayPage = true;

                        var InvestmentValuationExcelArr = [];
                        var count = 1;
                        for (var i = 0; i < data.length; i++) {
                            var InvestmentValuationExcelObj = {};
                            InvestmentValuationExcelObj.InvestmentValuationKey = count++;
                            //InvestmentValuationExcelObj.PartnerPartnerID = data[i][1];

                            InvestmentValuationExcelObj.InvestmentInvestmentID = data[i][0];

                            if(data[i][2])
                            {
                                 InvestmentValuationExcelObj.TaxYear = this._firstLetterToUpper(data[i][2].toString());
                            }
                            if(data[i][3])
                            {
                                 InvestmentValuationExcelObj.TaxQuarter =this._firstLetterToUpper(data[i][3]);
                            }
                            InvestmentValuationExcelObj.ProjectedValue = data[i][4];
                            InvestmentValuationExcelObj.CurrentValue = data[i][5];

                            InvestmentValuationExcelArr.push(InvestmentValuationExcelObj);
                        }
                        this.dataInvestmentValuationExcel = InvestmentValuationExcelArr;
                        //this.getPartnerDetails();
                        this.getInvestmentDetails();

                        var grid = $("#InvestmentValuationUploadGrid").data("kendoGrid");

                        grid.dataSource.data(this.dataInvestmentValuationExcel);
                        console.log(JSON.stringify(this.dataInvestmentValuationExcel));
                    }else{
                        this._AlertPopup("Template is Empty","error");
                    }

                    /* Update state */
                    //this.data = data;
                    //console.log(JSON.stringify(data));
                };
                reader.readAsArrayBuffer(file);
            } catch (ex) {
                console.log(ex);
                //this.$Progress.fail();
            }
        },
        // getPartnerDetails: function () {
        //     let partner = this.PartnerAPIData.slice();
        //     let dataInvestmentValuationExcel = this.dataInvestmentValuationExcel.slice();

        //     for (let i = 0; i < dataInvestmentValuationExcel.length; i++) {
        //         if (dataInvestmentValuationExcel[i].PartnerPartnerID) {
        //             var result = partner.filter(function (obj) {
        //                  if(obj.PartnerID){
        //                 return (obj.PartnerID.toString().trim().toLowerCase() == dataInvestmentValuationExcel[i].PartnerPartnerID.toString().trim().toLowerCase());
        //                 }

        //             })[0];
        //             if (result) {
        //                 dataInvestmentValuationExcel[i].PartnerTitle = result.FullName;
        //                 dataInvestmentValuationExcel[i].PartnerId=result.Id;
        //             }
        //         }
        //     }

        //     this.dataInvestmentValuationExcel = dataInvestmentValuationExcel;

        // },

        getInvestmentDetails: function () {
            let Investment = this.InvestmentAPIData.slice();
            let dataInvestmentValuationExcel = this.dataInvestmentValuationExcel.slice();

            for (let i = 0; i < dataInvestmentValuationExcel.length; i++) {
                if (dataInvestmentValuationExcel[i].InvestmentInvestmentID) {
                    var result = Investment.filter(function (obj) {
                       if(obj.InvestmentID)
                        {
                        return (obj.InvestmentID.toString().trim().toLowerCase() == dataInvestmentValuationExcel[i].InvestmentInvestmentID.toString().trim().toLowerCase());
                        }
                    })[0];
                    if (result) {
                        dataInvestmentValuationExcel[i].InvestmentTitle = result.Title;
                        dataInvestmentValuationExcel[i].InvestmentId=result.Id;
                    }
                }
            }
            this.dataInvestmentValuationExcel = dataInvestmentValuationExcel;
        },

        DeleteDIfromGrid: function (e) {
            //e.preventDefault();
            //alert("Delete button clicked from BaseGrid..");
            
             const message = "Are you sure you want to delete this record?";
             this._ConfirmationPopup(message,"DELETE").then((result) => {
             if (result.value) {
           
                var gview = window.$("#InvestmentValuationUploadGrid").data("kendoGrid");
                var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
                //var dataItem = JSON.stringify(window.$(e.currentTarget).closest("tr"));
                //alert(JSON.stringify(dataItem));
                let objIndex = this.dataInvestmentValuationExcel.findIndex(
                    obj => obj.InvestmentValuationKey == dataItem.InvestmentValuationKey
                );
                this.dataInvestmentValuationExcel.splice(objIndex, 1);
                var grid = $("#InvestmentValuationUploadGrid").data("kendoGrid");
                grid.dataSource.data(this.dataInvestmentValuationExcel);
            }
        })
        },
        getConfirmation: function () {
            var retVal = confirm(
                "You are about to delete this InvestmentValuation.Press ok to continue otherwise press cancel."
            );
            if (retVal == true) return true;
            else return false;
        },

        validateFn(e){
            
            let self = this;
            e.preventDefault();
            self.pageErrors = [];
            self.bValidated = true;
            let errorMessages = new Set();         
            let dataItem = $("#InvestmentValuationUploadGrid").data("kendoGrid").dataSource.data();

            dataItem.forEach((ele,i) => {
                
                self.Columns = [];

                //Investment Name
                let investIndex = self.InvestmentAPIData.findIndex(f => f.InvestmentID == ele.InvestmentInvestmentID)
                if(ele.InvestmentInvestmentID =="" || isNullOrUndefined(ele.InvestmentInvestmentID) || investIndex < 0){
                    self.Columns.push({"column":"InvestmentInvestmentID","row":i});                  
                    errorMessages.add("Investment ID is Empty or Invalid");
                }

                //Tax Year                
                let TaxYIndex = self.TaxYearOptions.findIndex(f => f.Option == ele.TaxYear)
                if(ele.TaxYear =="" || isNullOrUndefined(ele.TaxYear) || TaxYIndex < 0){
                    self.Columns.push({"column":"TaxYear","row":i});                    
                    errorMessages.add("Tax Year is Empty or Invalid");
                }

                //Tax Quarter   
                let TaxQIndex = self.TaxQuarterOptions.findIndex(f => f.Option == ele.TaxQuarter)
                if(ele.TaxQuarter =="" || isNullOrUndefined(ele.TaxQuarter) || TaxQIndex < 0){
                    self.Columns.push({"column":"TaxQuarter","row":i});                    
                    errorMessages.add("Tax Quarter is Empty or Invalid");
                }
                
                //Projected Value               
                if ((!ele.ProjectedValue && ele.ProjectedValue!=0 )|| isNaN(ele.ProjectedValue)){                    
                    self.Columns.push({"column":"ProjectedValue","row":i});                    
                    errorMessages.add("Projected Value is Empty or Invalid");
                }

                //Current Value               
                if ((!ele.CurrentValue && ele.CurrentValue!=0) || isNaN(ele.CurrentValue)){                    
                    self.Columns.push({"column":"CurrentValue","row":i});                    
                    errorMessages.add("Current Value is Empty or Invalid");
                }

                //Investment, Tax Year and Tax Quarter combo Duplicate in excel import
                dataItem.forEach((IVele,index) => {
                    if(index != i){
                        if(IVele.InvestmentInvestmentID == ele.InvestmentInvestmentID && IVele.TaxYear == ele.TaxYear && IVele.TaxQuarter == ele.TaxQuarter){
                            self.Columns.push({"column":"InvestmentInvestmentID","row":i});
                            self.Columns.push({"column":"TaxYear","row":i});
                            self.Columns.push({"column":"TaxQuarter","row":i});
                            // self.pageErrors.push(`Duplicate records found in the import data for the Investment ID(${ele.InvestmentInvestmentID}), Tax Year(${ele.TaxYear}), Tax Quarter(${ele.TaxQuarter})`);
                            errorMessages.add(`Duplicate records found in the import data for the Investment ID(${ele.InvestmentInvestmentID}), Tax Year(${ele.TaxYear}), Tax Quarter(${ele.TaxQuarter})`);
                        }
                    }

                });               

                
                //Investment, Tax Year and Tax Quarter combo exist in InvestmentValuation List
                let investcomboIndex = self.InvestmentValuationAPIData.findIndex(f => f.InvestmentInvestmentID == ele.InvestmentInvestmentID && f.TaxYear == ele.TaxYear && f.TaxQuarter == ele.TaxQuarter );
                if(investcomboIndex >= 0){
                    self.Columns.push({"column":"InvestmentInvestmentID","row":i});
                    self.Columns.push({"column":"TaxYear","row":i});
                    self.Columns.push({"column":"TaxQuarter","row":i});
                    // self.pageErrors.push(`Valuation already exist for the Investment ID(${ele.InvestmentInvestmentID}), Tax Year(${ele.TaxYear}), Tax Quarter(${ele.TaxQuarter})`);
                     errorMessages.add(`Valuation already exist for the Investment ID(${ele.InvestmentInvestmentID}), Tax Year(${ele.TaxYear}), Tax Quarter(${ele.TaxQuarter})`);
                }

                //Validation status for a row
                self.Columns.push({"column":"Validation","row":i});
                self.ValidateImportData('InvestmentValuationUploadGrid',self.Columns);                
            })
            self.pageErrors=[...errorMessages];
        },

        

        SaveInvestments: function () {
            const self = this;
            let NewInvestmentobject = {
                InvestmentValuation: {
                    config: BaseModelInvestmentValuation,
                    createData: this.dataInvestmentValuationExcel
                }
            };
             //let loader = this.$loading.show();
              self._APICrudPopup("APICrudpopup");
            //this._createAllItems(NewPartnerobject).then(addnewpartner => {
            this.CreateAllItems(NewInvestmentobject).then(InvestmentValuation => {
                console.log(InvestmentValuation);
                //self._AlertPopup("Investment Valuation data saved successfully", "success");
                 /** AUDIT DOCUMENT UPLOAD **/
            let FileUpload = [];
            let senderObj = {};
            //senderObj.Id = this.count++;
            let realfileName = this.inputfile.UploadFile[0].name;
            // senderObj.File = self._appendDatewithExcelName(fileName);
            senderObj.File = this.inputfile.UploadFile[0].upload.uuid
            senderObj.RealFileName = realfileName;
            senderObj.FileContent = this.inputfile.UploadFile[0];
            FileUpload.push(senderObj);
            this.UploadBulkAditFilesToDB(FileUpload)
                .then(response => {
                self._AlertPopup("Investment Valuation data saved successfully", "success");
                })
                .catch(error => {
                self._AlertPopup("Some Error Occurred!", "info");
                })
                .finally(() => {
                //loader.hide();
                });
            /** AUDIT DOCUMENT UPLOAD END */
            this.$refs.ParentFileUploaded.$refs.FileUploaded.removeAllFiles();
            }).catch(error=>{
                self._AlertPopup("Some Error Occurred!","info");
            }).finally(()=>{
                //loader.hide();
            })
        },
        ClearForm() {    
            this.dataInvestmentValuationExcel=[]  
            this.displayPage = false;
            this.pageErrors = [];
            this.bValidated=false;
        },

    },

    mounted() {
        let self = this;
         let response = self.getLocalInputControls(
            self.BaseModelInputControl.list
         );

        this.TaxYearOptions=response.TaxYear;
        this.TaxQuarterOptions=response.TaxQuarter; 
    }
};
</script>

<style>
.dropzone {
    border: 2px dashed #bbb;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    padding: 25px;
    text-align: center;
    font-size: 16px;
    color: #646464;
    height: 300px !important;
    padding-top: 50px !important;
}
</style>
